<template>
  <div class="w-full">
    <p
      v-if="packings.length === 0"
      class="text-center"
    >
      -
    </p>
    <ul
      v-else
      class="list-disc ml-[16px] mb-[16px]"
    >
      <li
        v-for="packing in packings"
        :key="packing.id"
        class="text-left"
      >
        <div class="flex justify-between items-center">
          <span>{{ packing.name }}</span>
          <span>{{ packing.layer }}x</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    packings: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
}
</script>
